module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-button', {
    on: {
      "click": _vm.testPrint
    }
  }, [_vm._v("测试按钮")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c83c5fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/test/CodingTest.vue
// module id = 830
// module chunks = 1